import { ColumnType } from 'antd/es/table';
import naturalCompare from 'natural-compare-lite';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Field } from 'api/tasks';
import { Table } from 'components/molecules/table';
import { Text02 } from 'components/styles';
import { FieldType, FieldStatus, MoreOption } from './list-item-components';

const Text = styled.div`
  &,
  & svg {
    ${Text02};
  }
`;

const StyledTable = styled(Table)`
  .is-private {
    background-color: var(--private-01);
    &:hover > td {
      background-color: var(--private-02);
    }
    td.ant-table-column-sort {
      background: inherit;
    }
    &:hover td.ant-table-column-sort {
      background: var(--private-02);
    }
  }
`;

const FieldStatusCellRenderer = (value: boolean, field: Field) => {
  return <FieldStatus value={value} field={field} />;
};

const MoreOptionsCellRenderer = (value, field: Field) => {
  return <MoreOption field={field} />;
};

const FieldTypeCellRenderer = (value, record: Field) => {
  return <FieldType field={record} />;
};

const columns: ColumnType<Field>[] = [
  {
    title: <FormattedMessage id="settings.fields.field.name" />,
    dataIndex: 'fieldLabel',
    key: 'fieldLabel',
    width: 200,
    ellipsis: true,
    sorter: ({ fieldLabel: prevValue }, { fieldLabel: nextValue }) =>
      prevValue && nextValue ? naturalCompare(prevValue, nextValue) : -1,
  },
  {
    title: <FormattedMessage id="description" />,
    dataIndex: 'description',
    key: 'description',
    render: (value: string) => <Text>{value}</Text>,
    width: 286,
    ellipsis: true,
    sorter: ({ description: prevValue }, { description: nextValue }) =>
      prevValue && nextValue ? naturalCompare(prevValue, nextValue) : -1,
  },
  {
    title: <FormattedMessage id="settings.fields.field.type" />,
    dataIndex: 'fieldType',
    key: 'fieldType',
    render: FieldTypeCellRenderer,
    width: 200,
  },

  {
    title: <FormattedMessage id="status" />,
    dataIndex: 'isEnabled',
    key: 'isEnabled',
    render: FieldStatusCellRenderer,
    width: 200,
    sorter: ({ isEnabled: prevValue }, { isEnabled: nextValue }) =>
      prevValue === nextValue ? 0 : prevValue ? -1 : 1,
    defaultSortOrder: 'ascend',
  },
  {
    dataIndex: 'fieldId',
    key: 'fieldId',
    width: 40,
    align: 'right',
    render: MoreOptionsCellRenderer,
  },
];

export const TaskFieldsList: FC<{
  data: Field[];
  loading?: boolean;
  offsetHeader?: number;
}> = ({ data, loading = false, offsetHeader }) => {
  return (
    <StyledTable
      dataSource={data}
      columns={columns}
      loading={loading}
      pagination={false}
      scroll={{ y: 'calc(100vh - 204px)' }}
      sticky={{ offsetHeader }}
      tableLayout="fixed"
      rowKey={(field: Field) => `${field.fieldId}`}
      rowClassName={(field: Field) => {
        return field.private ? 'is-private' : '';
      }}
      size="small"
    />
  );
};
